import accountTracker from "@/services/accountTracker"

export const useFetchAccountTracker = () => {
  const fetchAccountTracker = async () => {
    try {
      const { handler } = accountTracker

      const res = await handler()

      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return {
    fetchAccountTracker
  }
}

export default useFetchAccountTracker
